function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-3 -3 168 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M81.3,0c44.5,0.1,80.8,36.6,80.7,81.3c-0.1,44.5-36.6,80.8-81.3,80.7C36.2,162-0.1,125.4,0,80.7   C0.1,36.2,36.6-0.1,81.3,0z",
    style: {
      fill: "#f1f1f1",
      fillOpacity: 0,
      strokeWidth: 6
    },
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.223148,113.43466 h -13.125 L 36.113773,69.419037 V 113.43466 H 22.848148 V 45.184662 h 13.265625 l 18.84375,43.828125 0.04687,-43.828125 h 13.21875 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 96,
      fontFamily: "'Roboto Mono for Powerline'",
      InkscapeFontSpecification: "'Roboto Mono for Powerline Bold'",
      fillOpacity: 1
    },
    id: "path835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.502202,118.41035 H 66.869164 L 91.34795,47.399416 h 11.63304 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "91.98633575px",
      fontFamily: "'Roboto Mono for Powerline'",
      InkscapeFontSpecification: "'Roboto Mono for Powerline Bold'",
      fillOpacity: 1,
      strokeWidth: 0.95819098
    },
    id: "path832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125.49642,99.727707 H 105.01205 L 100.9808,113.97771 H 87.105797 L 109.46517,45.727707 h 11.95313 l 21.9375,68.250003 h -13.875 z m -17.25,-11.203125 h 14.15625 l -6.98437,-25.125 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 96,
      fontFamily: "'Roboto Mono for Powerline'",
      InkscapeFontSpecification: "'Roboto Mono for Powerline Bold'",
      fillOpacity: 1
    },
    id: "path829"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaIcon);
export default __webpack_public_path__ + "static/media/na-icon.f70f7c4e.svg";
export { ForwardRef as ReactComponent };